import { AppData, Log, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig, initSecurityToken } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import { AppSetup } from '../lib/app-setup'
import { Logger } from '../lib/logger'
import Router from '@lightningjs/sdk/src/Router'
import VideoScreenNew from '../pages/video-screen-new'


export class PlatformLG extends PlatformBase {
  libraryLoadPromise!: Promise<boolean[]>
  isWEBOSTV = false
  isVideoSuspended = false
  suspendedRoute = ''
  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      412: 'Rewind',
      417: 'Forward',
      418: 'Next',
      419: 'Previous',
      27: 'Exit',
      461: 'Back',
      403: 'Red',
      404: 'Green',
      405: 'Yellow',
      406: 'Blue'
    }

    //this._loadLibrary()
  }

  override setKeyMappings(appSettings: any) {
    appSettings.keys = this.keyMap
    //appSettings.enablePointer = true
    //appSettings.useMouse = true
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_REWIND = 412;
    KeyCodes.KEY_FORWARD = 417;
    KeyCodes.KEY_NEXT = 418;
    KeyCodes.KEY_PREVIOUS = 419;
    KeyCodes.KEY_BACK = 461;
    KeyCodes.KEY_RED = 403;
    KeyCodes.KEY_GREEN = 404;
    KeyCodes.KEY_YELLOW = 405;
    KeyCodes.KEY_BLUE = 406;
  }

  _loadLibrary() {
    this.libraryLoadPromise = Helper.getScripts([
      Utils.asset('/platform/lg/webOSTV.js'),
      Utils.asset('/platform/lg/webOSTV-dev.js'),
      // Utils.asset('/platform/core.min.js'),
      // Utils.asset('/platform/md5.js')
    ])
  }

  override async initialize(): Promise<boolean> {
    this._shouldShowExitPopup = true
    const { appState, appConfig } = AppData as AppSetup
    const app = appState?.getApp()!

    Log.info('PlatformBase:', typeof this)
    this._siteConfig = await getSiteConfig()
    appConfig.aContent = Helper.getAcontent()
    appConfig.enableSocialMediaParentalControl = true
    appConfig?.sendAdIdInUserLog = false
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    Helper.getSiteConfigInfo(this._siteConfig)
    
    if(appConfig.enableSecurityToken){
      appConfig?.apiVersion = "sv9.0";
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }

    this._loadLibrary()
    return new Promise(async (resolve, reject) => {

      Log.info('PlatformBase:', typeof this)
      const results = await this.libraryLoadPromise
      const promiseArry = []
      if (results[0]) {
        Log.info('PlatformBase: scriptLoading status:', results)
        Log.info('PlatformBase: WebOS_LOAD:')
        promiseArry.push(this._getDeviceId())
        promiseArry.push(this._getDeviceInfo())
        this.isWEBOSTV = true
        await Promise.all(promiseArry)
        resolve(true)
      } else {
        Log.info('PlatformBase: scriptLoading status failed', results)
        resolve(true)
      }

      document.addEventListener("visibilitychange", (event) => {
        Log.info('visibilitychange: ', document.hidden)
        const { appConfig, appState } = AppData as AppSetup;
        if (document.hidden) {
          appState.appUnload = true
          const route = Router.getActiveRoute()!
          const appInstance = appState?.getApp()
          if (route.indexOf('video') > -1) {
            const isLive = route.indexOf('video-screen-live') > -1
            const page = Router.getActivePage() as any
            appState?.sessionTimeState.stopTimer()
            if (isLive) {
              page.hitCloseTracker()
              page.ftStreamingPlayer?.stopLoad()
              page.hideVideo()
            } else {
              page.hitCloseTracker()
              (page as VideoScreenNew).closeVideo(true)
              appInstance?.handleBackNavigation();
            }
            this.isVideoSuspended = true
            this.suspendedRoute = route
          }
          Logger.processUserAction('userExitedViaRemoteDirectly', 'App suspended')
        } else {
          // when the app gets resumed
          appConfig.sessionId = Helper.generateSessionId();
          //reset the sessions timer on resume as session id is refreshed.
          appState?.sessionTimeState.startTimer()
          Log.info('appResumed: sessionId', appConfig.sessionId)
          if (this.isVideoSuspended) {
            if (this.suspendedRoute.indexOf('video-screen-live') > -1) {
              const livePage = Router.getActivePage() as any
              livePage?.resumePlayer()
            } else {
              const vodInfo = app.navigation.getCurrentVodInfo()
              Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
            }
            this.isVideoSuspended = false
          }
          Logger.processUserAction('appResumedFromSuspend', 'App resumed')
        }
        //console.log("APP: BEFORE UNLOAD APP");
      });

      document.addEventListener('webOSRelaunch', (data) => {
        Log.info('WebOS: webOSRelaunch');
        var params = window.webOSDev.launchParams()
        Log.info('WebOS: webOSDev.launchParams():' + JSON.stringify(params));
        Logger.processUserAction('DeeplinkReceived', JSON.stringify(params))
        if (params.contentTarget !== undefined) {
          var tplayId = params.contentTarget.split('_')[0]
          var dtype = this._getDeeplinkType(params.contentTarget.split('_')[1])
          var isJsonText = params.contentTarget.indexOf('{') == 0 ? true : false;
          if (isJsonText) {
            var deepjson = JSON.parse(params.contentTarget)
            if (deepjson && deepjson.playId) {
              tplayId = deepjson.playId.split('_')[0]
              dtype = this._getDeeplinkType(deepjson.playId.split('_')[1])
            }
          }
          const { appState } = AppData as AppSetup
          const app = appState?.getApp()!
          const route = Router.getActiveRoute()!
          if (route.indexOf('video') > -1) {
            const page: VideoScreenNew = Router.getActivePage()
            page.hitCloseTracker()
            page.closeVideo(true)
            app?.handleBackNavigation();
          }
          app.loadDeeplinkInterrupt(`?playId=${tplayId}&src=${dtype}`)
        }
      });
    })
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'close':
        if (window.webOS) {
          window.close()
        }
        break;
    }
  }

  override getPlatformDeeplinkData(): Promise<string> {
    return new Promise((resolve, reject) => {
      //resolve('')
      let contentChangeUrl = location.search
      const playId = Helper.getIptvParameterFromUrl('playId', contentChangeUrl);
      Log.info('window.webOS: ', window.webOS)
      Log.info('window.webOSDev: ', window.webOSDev)
      if (window.webOS.platform.tv === true) {
        const params = window.webOSDev.launchParams();
        Logger.processUserAction('DeeplinkReceived', JSON.stringify(params))
        if (params.contentTarget !== undefined) {
          let tplayId = params.contentTarget.split('_')[0]
          let isJsonText = params.contentTarget.indexOf('{') == 0 ? true : false;
          let dtype = this._getDeeplinkType(params.contentTarget.split('_')[1])
          if (isJsonText) {
            var deepjson = JSON.parse(params.contentTarget)
            if (deepjson && deepjson.playId) {
              tplayId = deepjson.playId.split('_')[0]
              dtype = this._getDeeplinkType(deepjson.playId.split('_')[1])
            }
          }

          resolve(`?playId=${tplayId}&src=${dtype}`)
        } else {
          resolve('')
        }
      } else {
        if (playId && playId !== '') {
          let tplayId = playId.split('_')[0]
          let dtype = this._getDeeplinkType(playId.split('_')[1])
          resolve(`?playId=${tplayId}&src=${dtype}`)
        } else {
          resolve('')
        }
      }

      // if (playId !== undefined && playId !== '') {
      //   deeplinks.sourceType = 'hs-d';
      //   deeplinks.playId = playId;
      //   resolve(`?playId=${deeplinks.playId}&src=${deeplinks.sourceType}`)
      // } else if (searchKeys !== undefined && searchKeys !== '') {
      //   deeplinks.sourceType = 'hs-search';
      //   deeplinks.playId = playId;
      //   resolve(`?${contentChangeUrl?.split('?')[1]}`)
      // } else {
      //   resolve('')
      // }
    })
  }

  // The regex matches 'search' or 'promo' globally


  _getDeeplinkType(dType: string): string {
    const regex = /\\+$/;
    const _dType = dType.replace(regex, '')
    switch (_dType) {
      case 'search':
        return 'hs-search'
      case 'promo':
        return 'hs-d'
      case 'preview':
      case '':
        return 'recommendationbytheapp'
      default:
        return 'hs-search'
    }
  }


  _getDeviceInfo(): Promise<boolean> {
    return new Promise((resolve) => {
      if (webOS.platform.tv === true) {
        webOS.deviceInfo(deviceInfo=>{
          this._fullModel = deviceInfo.modelName
          this._firmwareVersion = deviceInfo.sdkVersion
          resolve(true)
        })        
      } else {
        resolve(true)
      }
    })
  }

  _getDeviceId(): Promise<boolean> {
    return new Promise((resolve) => {
      Log.info("getLGDeviceId() called");
      if (webOS.platform.tv === true) {
        this.isDevice = true;
        webOSDev.LGUDID({
          onSuccess: (res) => {
            if (res.id) {
              this._deviceId = res.id
              this._ifa = this._deviceId
              //Fix for XFIN-1201
              this._ifaType = 'lgudid'
              this._limitAdTracking = "0"
              Log.info('LGUDID :', this.getDeviceId())
              resolve(true)
            }
          },
          onFailure: function (error) {
            // API calling error
            resolve(true)
            Log.info('error while getting LGUDID', error.errorText);
          }
        });
      } else {
        resolve(true)
        Log.info('This device is not TV.');
      }
    })
  }

  override getAppStoreId(type = ''): string {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    if (type == 'ad') {
      if (appApiConfig && appApiConfig.appConfig.lgAppstoreId) {
        return appApiConfig.appConfig.lgAppstoreId
      }
    }
    return ''
  }

  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    // if(apiOptionsIcon && apiOptionsIcon !== '') {
    //   return apiOptionsIcon
    // }
    const { appConfig } = AppData as AppSetup
    if(appConfig?.appEnv == 'auto') {
      return Utils.asset('images/option_touch.png')
    }
    return Utils.asset('images/option-blue.png')
  }


  override isOptionsKey(e: KeyboardEvent): boolean {
    // console.log('isOptionsKey: ', e)
    if (e.keyCode == KeyCodes.KEY_BLUE || e.code == 'KeyB') {
      return true
    }
    return false
  }

  override getOptionsText() {
    const { appConfig } = AppData as AppSetup
    if(appConfig?.appEnv == 'auto') {
      return 'Hold for Options'
    }
    return 'Press Blue for Options'
  }

  override getScript(platformSettings): string[] {
    return [
      'https://code.jquery.com/jquery-3.7.0.min.js',
      platformSettings.path + 'modules/hlsjs/hls.min.js',
      platformSettings.path + 'modules/dashjs/dash.all.min.js',
      'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
    ]
  }

  override getAppOptions(appSettings: any, platformSettings: any) {
    const canvas = document.createElement('canvas')
    const vw = window.innerWidth;   //less safeFrame
    //const vh = window.innerHeight; //less safeFrame
    //const scalling: any = vh == 1080 ? 1 : ((vh / 1080).toPrecision(7));
    const scalling: any = ((vw / 1920).toPrecision(7));
    canvas.setAttribute('style', 'position: absolute;z-index: 2;')
    //document.body.appendChild(canvas) 
    appSettings.stage.canvas = canvas
    //const precision:any = vh == 1080 ? 1 : ((vh / 1080).toPrecision(7));
    const precision = scalling
    appSettings.stage.w = Math.round(vw)
    appSettings.stage.h = Math.round(1080 * scalling)
    appSettings.stage.precision = precision
    appSettings.stage.memoryPressure = 10e6
    appSettings.stage.fontSharp =
    {
      precision: 1,
      fontSize: 21,
    }
    window.platformSettings = platformSettings as PlatformSettings
  }

  override showGridArrowButtons(): boolean {
    return true
  }
}
